import createDecorator from 'final-form-calculate';
import Checkbox from 'components/form/fields/Checkbox/Checkbox';
import { SideText } from 'components/form/fields/Checkbox/SideText';
import DateTimePicker from 'components/form/fields/DateTimePicker/DateTimePicker';
import Dropdown from 'components/form/fields/Dropdown/Dropdown';
import Editor from 'components/form/fields/Editor/Editor';
import MultipleChoice from 'components/form/fields/MultiChoice';
import TextInput from 'components/form/fields/TextInput/TextInput';
import { Widgets } from 'components/form/fields/Widgets/Widgets';
import { slugNormalizer } from 'core/helpers/normalizers';
import { checkSlugs } from './redux';
import { toast } from 'react-toastify';
import { createSelector } from 'reselect';

export const formConfig = {
  fields: [
    {
      component: TextInput,
      isRequired: true,
      name: 'title',
      title: 'Title',
      translatable: true,
    },
    [
      {
        component: DateTimePicker,
        name: 'publishDate',
        title: 'Publish date',
      },
      {
        component: Checkbox,
        name: 'isPublished',
        roles: ['admin', 'superadmin'],
        title: 'Is published',
        hasSideComponent: true,
        sideComponent: SideText,
      },
    ],
    [
      {
        component: TextInput,
        isRequired: true,
        name: 'slug',
        normalizer: slugNormalizer,
        title: 'Slug',
      },
      {
        component: Checkbox,
        name: 'isSlugNotSynchronized',
        title: 'Do not synchronize the slug and the title',
      },
    ],
    {
      component: Editor,
      name: 'preview',
      title: 'Preview',
      translatable: true,
      isRequired: true,
    },
    {
      component: Editor,
      name: 'content',
      title: 'Content',
      translatable: true,
      isRequired: true,
    },
    {
      component: Dropdown,
      name: 'categoryId',
      options: (props: any) => [
        {
          label: 'NO',
          value: null,
        },
        ...props.categories.map((item: any) => ({
          label: item.title,
          value: item.id,
        })),
      ],
      title: 'Category',
    },
    {
      component: MultipleChoice,
      dictionary: 'hashtags',
      name: 'hashtags',
      optionsMap: {
        label: 'name',
        value: 'id',
      },
      title: 'Hashtags',
    },
    {
      component: Widgets,
      name: 'widgets',
      title: 'Widgets',
    },
  ],
  title: 'Article',
  withPermission: true,
};

const slugsDecorator = (initialValues: any) =>
  createDecorator(
    {
      field: 'title',
      updates: {
        slug: async (
          value: string,
          allValues: any,
          prevValues: any,
        ): Promise<string> => {
          const slug =
            allValues.isSlugNotSynchronized ||
            !prevValues.hasOwnProperty('slug')
              ? allValues.slug
              : await slugNormalizer(value);

          if (slug === initialValues.slug) {
            return slug;
          }

          if (!allValues.isSlugNotSynchronized) {
            try {
              const { data } = await checkSlugs(slug);

              if (Array.isArray(data)) {
                return data[0];
              }
            } catch (error) {
              if (error.message !== '404') {
                toast.error(error.message);
              }
            }
          }

          return slug;
        },
      },
    },
    {
      field: 'isSlugNotSynchronized',
      updates: {
        slug: (value: string, allValues: any): string => {
          return value ? allValues.slug : slugNormalizer(allValues.title);
        },
      },
    },
  );

export const decorators = createSelector(
  initialValues => initialValues,
  (initialValues: any) => [slugsDecorator(initialValues)],
);
